export default __webpack_public_path__ + "static/media/PlusSign.ea7dce3e.svg";